import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpErrorResponse,
    HttpResponse
  } from '@angular/common/http';
  import { Injector, Injectable } from '@angular/core';
  import { E2eService, SvcServices } from '../../../services';
  import { Observable, throwError } from 'rxjs';
  import { filter,tap, catchError } from 'rxjs/operators';
  @Injectable()
  export class E2EInterceptor implements HttpInterceptor {
    constructor(private injector: Injector) { }
  
    get e2eService(): E2eService{
      return this.injector.get(E2eService);
    }
  
    get svcService(): SvcServices {
      return this.injector.get(SvcServices);
    }
  
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      return next.handle(request)
        .pipe(
          catchError((error: HttpErrorResponse) => this.errorHandler(error)),
          filter((event: HttpEvent<any>) => event instanceof HttpResponse ),
          tap((response: HttpResponse<any>) => this.receive(response)),
          
          );
    }
  
    errorHandler(error: HttpErrorResponse) {
      if (this.svcService.isFusionChannel() && error && error.headers && error.headers.has('eventid') && error.headers.has('eventidexpirytime')) {
        
          const eventId = error.headers.get('eventid')
          this.e2eService.setEventId(eventId);   
        
        
      }
      return throwError(error);
    }
  
    receive(response: HttpResponse<any>): void {
      if (this.svcService.isFusionChannel() && response.headers.has('eventid') && response.headers.has('eventidexpirytime')) {
        const eventId = response.headers.get('eventid')
        this.e2eService.setEventId(eventId); 
      }
    }
  }